<modal-component>

	<!-- LEFT-->
	<ng-container left>
		<div class="_header">
			<p class="_title" *ngIf="action === 'create'" >{{'EVENT.LESSONS.CREATE' | translate}}</p>
			<p class="_title" *ngIf="action === 'update'" >{{'EVENT.LESSONS.EDIT' | translate}}</p>
		</div>

		<div class="_info _new-event" >
			<div class="_lesson">
				<ion-icon src="./assets/icons/education-outline.svg"></ion-icon>
				<b [translate]="'EVENT_ATTENDANCE_TYPE.LESSONS'"></b>
				<p [translate]="'EVENT_ATTENDANCE_TYPE.LESSONS_INFO'"></p>
			</div>

		</div>
	</ng-container>

	<!-- RIGHT -->
	<ng-container right>	
		<form [formGroup]="lessonForm">
			<form-input label="{{'EVENT.LESSONS.TITLE' | translate}}" [formControl]="lessonForm.get('name') | cast"></form-input>

			<form-input label="{{'EVENT.LESSONS.DESCRIPTION' | translate}}" [formControl]="lessonForm.get('description') | cast"></form-input>


			<form-date 
				label="{{'EVENT.STARTS_AT' | translate }}" [formControl]="lessonForm.get('startsAt') | cast">
			</form-date>

			<div class="_start-end-time">
				<form-time label="{{'EVENT.START_TIME' | translate}}" [formControl]="lessonForm.get('startTime') | cast"></form-time>
				<form-time label="{{'EVENT.END_TIME' | translate}}" [formControl]="lessonForm.get('endTime') | cast"></form-time>
			</div>

		</form>

	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>
		<button *ngIf="action === 'create'" (click)="createLesson()" class="_button _save-button">
			<span [translate]="'EVENT.LESSONS.CREATE'"></span>
		</button>
		<button *ngIf="action === 'update'" (click)="updateLesson()" class="_button _save-button">
			<span [translate]="'EVENT.LESSONS.UPDATE'"></span>
		</button>
		<button *ngIf="action === 'update'" (click)="deleteLesson()" class="_button _delete-button">
			<span [translate]="'EVENT.LESSONS.DELETE'"></span>
		</button>
	</ng-container>

</modal-component>
